import { ChangeEvent, useState } from "react";
import { useAppSelector } from "Redux/hooks";
import AlternativeButton from "../Atoms/AlternativeButton";
import Button from "../Atoms/Button";
import LinkEditor from "../Molecule/LinkEditor";
import ReferenceEditor from "../Molecule/ReferenceEditor";
import TermEditor from "../Molecule/TermEditor";
import { TextElement } from "types/types";
import { JSONContent } from "@tiptap/react";
import { leanEntries } from "Constants/defaultStyles";
import { selectStyle } from "Redux/appSlice";

/*
  @function PopUpAddElements
  a popUp screen to add elements
  @param type {string} - type of element
  @param defaultValue {object} - default values
  @param onSet {function} - called on set
  @param onCancel {function} - called to cancel the operation
  @param helpInfo {object} - help information for popup
*/

let editor: Partial<JSONContent> = {};

type ElementType =
  | "Link"
  | "Reference"
  | "Term"
  | "Trigger"
  | "Progress"
  | "Email"
  | "Module"
  | null;

type Text = {
  name: string;
  description?: TextElement;
  email?: string;
  is_free?: boolean;
  is_live?: boolean;
};

export default function PopUpAddElements({
  type,
  defaultValue,
  onSet,
  onCancel,
}: {
  type: ElementType;
  defaultValue?: Record<string, any>;
  onSet: (type: ElementType, text: any) => void;
  onCancel: () => void;
}) {
  const { color1 } = useAppSelector(selectStyle);
  const [text, setText] = useState<Text>();

  const updateText = (
    { target: { value } }: ChangeEvent<HTMLInputElement>,
    key: any
  ) => {
    setText((state) => {
      return { ...state, [key]: value };
    });
  };

  return (
    <div className="absolute h-full w-full bg-black/80 z-20">
      <div
        style={{ background: leanEntries.color2 }}
        className="absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 rounded-lg p-8"
      >
        {type === "Progress" && (
          <p className="text-center pb-2" style={{ color: color1 }}>
            Save your Progress
          </p>
        )}
        {type !== "Email" && type !== "Progress" && (
          <p className="text-center pb-2" style={{ color: color1 }}>
            Create {type}
          </p>
        )}
        {type !== "Progress" && (
          <p className="text-center pb-2" style={{ color: color1 }}>
            Save {type}
          </p>
        )}
        <form className="flex flex-col ">
          {type === "Term" && (
            <TermEditor
              text={text}
              onUpdateStrings={updateText}
              onUpdateRichText={(val) => (editor = val)}
            />
          )}
          {type === "Link" && (
            <LinkEditor
              text={text}
              onUpdateStrings={updateText}
              onUpdateRichText={(val) => (editor = val)}
            />
          )}
          {type === "Reference" && (
            <ReferenceEditor
              text={text}
              onUpdateStrings={updateText}
              onUpdateRichText={(val) => (editor = val)}
            />
          )}
          {type === "Email" && (
            <>
              <label className="text-center m-2">
                Please type the email address where you want to send the Final
                Report:
              </label>
              <input
                type="text"
                id="email"
                name="email"
                value={text?.email ? text.email : defaultValue?.Email}
                className="border border-2 border-black m-6"
                onChange={({ target: { value } }) =>
                  setText((state) => {
                    return { ...state, email: value };
                  })
                }
              />
            </>
          )}
          {type === "Progress" && (
            <>
              <input
                type="text"
                id="name"
                name="name"
                className="border border-2 border-black m-6"
                onChange={({ target: { value } }) =>
                  setText({ ...text, name: value })
                }
              />
            </>
          )}
          {type === "Module" && (
            <>
              <label className="text-center m-2">Name</label>
              <input
                type="text"
                id="name"
                name="first"
                value={text?.name ? text.name : ""}
                className="border border-2 border-black m-6"
                onChange={({ target: { value } }) =>
                  setText({ ...text, name: value })
                }
              />
              <div>
                <label className="text-center m-2">is free? </label>
                <input
                  type="checkbox"
                  id="is_free"
                  name="is_free"
                  // value={text?.is_free ? text.is_free : ""}
                  className="border border-2 border-black m-6"
                  onChange={(value) => {
                    setText((state) => {
                      return { ...state, is_free: value.target.checked };
                    });
                  }}
                />
              </div>
              <div>
                <label className="text-center m-2">is live? </label>
                <input
                  type="checkbox"
                  id="is_live"
                  name="is_live"
                  // value={text?.is_live ? text.is_live : ""}
                  className="border border-2 border-black m-6"
                  onChange={(value) =>
                    setText((state) => {
                      return { ...state, is_live: value.target.checked };
                    })
                  }
                />
              </div>
            </>
          )}
        </form>
        <div className="flex justify-between">
          <Button
            className="m-2"
            id="continueButton"
            onClick={() => onSet(type, { ...text, description: editor })}
            label={type === "Progress" || type === "Email" ? "save" : "create"}
          />
          <div className="inline m-2">
            <AlternativeButton
              id="cancelButton"
              onClick={onCancel}
              label="cancel"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
